import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';

import { PageContainer, Section } from '../../../shared/ui';
import { appendYowanPreviewQueryIfNeeded } from '../../../app/host/yowanPreviewRouting';
import { loginYowan } from '../app/yowanAuthClient';
import { useYowanAuth } from '../app/YowanAuthContext';
const { yowanPageContent } = require('./pageContent');
const { getYowanRouteMeta } = require('../routes/manifest');

const LoginPage = () => {
  const content = yowanPageContent['/login'];
  const metadata = getYowanRouteMeta('/login');
  const location = useLocation();
  const navigate = useNavigate();
  const { auth, syncAuth } = useYowanAuth();
  const currentUser = auth.currentUser;
  const [submitFeedback, setSubmitFeedback] = useState({ message: '', isError: false });
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: {
      email: '',
      password: '',
    },
  });

  useEffect(() => {
    if (!metadata) {
      return;
    }

    document.title = metadata.title;

    if (metadata.description) {
      const descriptionTag = document.querySelector('meta[name="description"]');
      if (descriptionTag) {
        descriptionTag.setAttribute('content', metadata.description);
      }
    }
  }, [metadata]);

  const onSubmit = async (values) => {
    try {
      await loginYowan(values);
      await syncAuth();
      setSubmitFeedback({
        message: 'ログインしました。認証状態を更新しています。',
        isError: false,
      });

      navigate(appendYowanPreviewQueryIfNeeded('/mypage', location.search));
    } catch (error) {
      setSubmitFeedback({
        message: 'ログインに失敗しました。入力内容をご確認ください。',
        isError: true,
      });
    }
  };

  return (
    <Section>
      <PageContainer>
        <div className="yowan-login-shell">
          <div className="yowan-login-panel c-surface-content">
            <div className="yowan-login-panel__body">
              <h1 className="yowan-login-panel__title">{content.header.title}</h1>
              {content.header.paragraphs.map((paragraph) => (
                <p key={paragraph} className="yowan-login-panel__lead">
                  {paragraph}
                </p>
              ))}
              {currentUser.isAuthenticated ? (
                <p className="yowan-login-panel__lead">
                  現在ログイン済みです。
                  <br />
                  <a
                    href={appendYowanPreviewQueryIfNeeded('/mypage', location.search)}
                    className="yowan-login-form__forgot"
                  >
                    マイページへ
                  </a>
                  {currentUser.canAccessAdmin ? (
                    <>
                      {' / '}
                      <a
                        href={appendYowanPreviewQueryIfNeeded('/admin', location.search)}
                        className="yowan-login-form__forgot"
                      >
                        管理画面へ
                      </a>
                    </>
                  ) : null}
                </p>
              ) : null}
            </div>

            <form className="yowan-login-form c-form" onSubmit={handleSubmit(onSubmit)}>
              <label className="c-form__field">
                <span className="c-form__label">
                  {content.form.labels.email}
                  <em className="c-form__required">*</em>
                </span>
                <input
                  className="c-form__control"
                  type="email"
                  {...register('email', { required: content.form.errors.required })}
                />
                {errors.email ? (
                  <em className="yowan-login-form__error">{errors.email.message}</em>
                ) : null}
              </label>

              <label className="c-form__field">
                <span className="c-form__label">
                  {content.form.labels.password}
                  <em className="c-form__required">*</em>
                </span>
                <input
                  className="c-form__control"
                  type="password"
                  {...register('password', { required: content.form.errors.required })}
                />
                {errors.password ? (
                  <em className="yowan-login-form__error">{errors.password.message}</em>
                ) : null}
              </label>

              <button type="submit" className="c-form__submit">
                {content.form.submitLabel}
              </button>

              <a
                className="yowan-login-form__forgot"
                href={appendYowanPreviewQueryIfNeeded(content.form.forgotPasswordHref, location.search)}
              >
                {content.form.forgotPasswordLabel}
              </a>

              {submitFeedback.message ? (
                <p
                  className={
                    submitFeedback.isError
                      ? 'yowan-login-form__error'
                      : 'yowan-login-form__message'
                  }
                >
                  {submitFeedback.message}
                </p>
              ) : null}
            </form>
          </div>
        </div>
      </PageContainer>
    </Section>
  );
};

export default LoginPage;
